export default __webpack_public_path__ + "static/media/home.d922ef09.svg";